import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    notificationLimitationTitle: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.title',
    }),

    notificationLimitationDescription: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.description',
    }),

    liveEtaRequiredTitle: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.liveEtaRequired.title',
    }),

    liveEtaRequiredDescription: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.liveEtaRequired.description',
    }),

    liveEtaNotAvailableForUserTitle: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.liveEtaNotAvailableForUser.title',
    }),

    liveEtaRequiredOnAllVehiclesTitle: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.liveEtaRequiredOnAllVehicles.title',
    }),

    liveEtaNotAvailableForUserDescription: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.liveEtaNotAvailableForUser.description',
    }),

    liveEtaRequiredOnAllVehiclesDescription: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.liveEtaRequiredOnAllVehicles.description',
    }),
    navigateToVehiclesLabel: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.navigateToVehicles.label',
    }),
    navigateToOrderScheduledTodayLabel: translate({
      id: 'sms4.settings.communication.notifications.form.notificationLimitation.navigateToOrderScheduledToday.label',
    }),
  }))

  return api
}
